import { Dispatch } from "@/domain/entities/Dispatch";
import jsPDF from "jspdf";

export type PDFDocument = jsPDF & {
  lastAutoTable: {
    finalY: number;
  };
};

export class PDFStyles {
  font: "helvetica" | "times" | "courier" | string = "helvetica";
  fontStyle: "normal" | "bold" | "italic" | "bolditalic" | string = "normal";
  fillColor = "#ffffff";
  textColor = "#000000";
  halign: "left" | "center" | "right" | "justify" = "left";
  fontSize = 7;
  cellPadding = { top: 0, right: 0, bottom: 0, left: 0 };
  cellWidth: "auto" | "wrap" | number = "auto";

  constructor(fields?: Partial<PDFStyles>) {
    Object.assign(this, fields);
  }
}

export class PDFConfig {
  columnStyles: Record<number, { cellWidth: number }> = {};
  tableColumns: Array<{ header: string; dataKey: string }> = [];

  constructor(fields?: Partial<PDFConfig>) {
    Object.assign(this, fields);
  }
}

export class PDFComponentProps {
  doc!: PDFDocument | any;
  translate!: (key: string) => string;
  x = 0;
  y = 0;
  pageWidth = 0;
  pageHeight = 0;

  constructor(fields?: Partial<PDFComponentProps>) {
    Object.assign(this, fields);
  }
}

export class TableComponentProps {
  doc!: PDFDocument | any;
  data: Array<any> = [];
  dataLength = 0;
  x = 0;
  y = 0;
  translate?: (key: string) => string;

  constructor(fields?: Partial<TableComponentProps>) {
    Object.assign(this, fields);
  }
}

export class FailedDispatchPDFProps {
  doc!: jsPDF;
  dataHead!: Dispatch;
  data: Array<any> = [];
  logo = "";

  constructor(fields?: Partial<FailedDispatchPDFProps>) {
    Object.assign(this, fields);
  }
}

export class DispatchSttFailedProps {
  doc!: jsPDF;
  sttData!: Dispatch;
  logo: any = "";

  constructor(fields?: Partial<DispatchSttFailedProps>) {
    Object.assign(this, fields);
  }
}
